<template>
  <div class="hist-legend left-column">
    <cat-block v-for="(category, index) in state.categories" 
      :key="category.name" 
      :category="category"
      :catIndex="index">
    </cat-block>
  </div>
</template>

<script>
import LegendCatBlock from './LegendCatBlock';

export default {
  name: 'heat-map-legend',
  props: ['state'],
  components: {
    'cat-block': LegendCatBlock,
  },
};
</script>

<style scoped>
  .hist-legend {
  }
</style>



// WEBPACK FOOTER //
// HeatMapLegend.vue?9e8f50cc